import React from 'react'

export default function NotFound() {
    return (
        <div>
            <h1>Page not FOund 404</h1>
        </div>
    )
}
